import Vue from "vue";

export async function getJustifications(justification_type) {
  const response = await Vue.prototype.$http.get(
    `justifications/${justification_type}`
  );

  return response.data;
}
